/* Shopping cart */

$(document).ready(function() {

  /* Shopping cart product preview using drift-zoom library */

  $('.js-order-recap').each(function(){
    var image = $(this).find('.js-order-recap-image').get(0);
    if (image) {
      var preview = $(this).find('.js-order-recap-preview').get(0);

      new Drift(
        image, {
        paneContainer: preview,
        inlinePane: false,
        hoverBoundingBox: true,
        handleTouch: false,
        boudingBoxContainer: $(image).parent().get(0),
        onShow: function() {
          $(preview).show();
        },
        onHide: function() {
          $(preview).hide();
        }
      });
    }


  });

});
